import { createContext, useCallback, useMemo, useState, useEffect, useContext } from "react";
import { AuthService } from "../services/api/usuario/auth/AuthService";

interface IAuthContextData {
  logout: () => void;
  login: (email: string, password: string) => Promise<string | void | Error>;
  isAuthenticated: boolean;
}

const LOCAL_STORAGE_KEY__ACESS_TOKEN = 'ACESS_TOKEN';

const AuthContext = createContext({} as IAuthContextData)

interface IAuthProviderProps {
  children: React.ReactNode
}

export const AuthProvider: React.FC<IAuthProviderProps> = ({ children }) => {
  const [acessToken, setAcessToken] = useState<string>();

  useEffect(() => {
    const acessToken = localStorage.getItem(LOCAL_STORAGE_KEY__ACESS_TOKEN);

    if (acessToken) {
      setAcessToken(JSON.parse(acessToken));
    } else {
      setAcessToken(undefined);
    }
  }, [])

  const handleLogin = useCallback(async (email: string, password: string) => {
    const result = await AuthService.auth(email, password);

    if (result instanceof Error) {
      return result;
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY__ACESS_TOKEN, JSON.stringify(result));
      setAcessToken(result);
    }
  }, []);

  const handleLogout = useCallback(() => {
    setAcessToken(undefined);
    localStorage.removeItem(LOCAL_STORAGE_KEY__ACESS_TOKEN);
    localStorage.removeItem("AlterarSenha");

  }, []);

  const isAuthenticated = useMemo(() => !!acessToken, [acessToken]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login: handleLogin, logout: handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);